import {
    DELIVERY,
    DELIVERY_ALIPAY,
    DELIVERY_BANK_ACCOUNT,
    DELIVERY_BANK_CARD,
    DELIVERY_CASH,
    DELIVERY_HOME,
    DELIVERY_SWIFT,
    DELIVERY_UNITELLER_MASTERCARD_BANK_CARD,
    DELIVERY_UPI,
    DELIVERY_VIA_PHONE_NUMBER,
    DELIVERY_VISA_BANK_CARD,
    DELIVERY_WALLET,
    DELIVERY_WECHAT,
    PAYMENT,
    PAYMENT_ACH,
    PAYMENT_BANK_ACCOUNT,
    PAYMENT_BANK_CARD,
    PAYMENT_DEBIT_BANK_CARD_111,
    PAYMENT_CREDIT_BANK_CARD_112,
    PAYMENT_BLIK,
    PAYMENT_BONUS,
    PAYMENT_EPS,
    PAYMENT_FLINKS,
    PAYMENT_GIROPAY,
    PAYMENT_GLOBAL_ACCOUNT,
    PAYMENT_GOOGLE_PAY,
    PAYMENT_IDEAL,
    PAYMENT_INTERAC,
    PAYMENT_PEOPLE_TRUST_INTERAC,
    PAYMENT_MBWAY,
    PAYMENT_OFAKIM,
    PAYMENT_SOFORT,
    PAYMENT_KLARNA,
    PAYMENT_USA_BANK_ACCOUNT,
    PAYMENT_BANK_CARD_110,
    PAYMENT_PAYPAL,
    DELIVERY_SEPA,
    PAYMENT_MODULR,
    PAYMENT_PLAID,
    PAYMENT_TINK,
    PAYMENT_TRUSTLY,
    DELIVERY_UNIONPAY_BANK_CARD,
} from 'apps/auth/constants/Constants';
import { PAKISTAN } from 'apps/auth/constants/WellKnownCountries';

type MethodName = string;
type CountryId = string | number;
type CheckMessages = Record<string, string | undefined>;

const getDeliveryPrefix = (messages: CheckMessages, methodName: MethodName, countryId?: CountryId): string | undefined => {
    if (
        methodName === DELIVERY_BANK_CARD ||
        methodName === PAYMENT_BANK_CARD ||
        methodName === DELIVERY_VISA_BANK_CARD ||
        methodName === DELIVERY_UNIONPAY_BANK_CARD ||
        methodName === DELIVERY_UNITELLER_MASTERCARD_BANK_CARD
    ) {
        return messages.transferToCard;
    } else if (
        methodName === DELIVERY_BANK_ACCOUNT ||
        methodName === PAYMENT_BANK_ACCOUNT ||
        methodName === DELIVERY_WECHAT ||
        methodName === DELIVERY_SEPA ||
        methodName === DELIVERY_SWIFT
    ) {
        return messages.transferToAccount;
    } else if (methodName === DELIVERY_WALLET && countryId === PAKISTAN) {
        return messages.transferToPhone;
    } else if (methodName === DELIVERY_VIA_PHONE_NUMBER) {
        return messages.transferToCardViaPhone;
    } else if (methodName === DELIVERY_WALLET || methodName === DELIVERY_UPI || methodName === DELIVERY_ALIPAY) {
        return messages.transferToWallet;
    } else if (methodName === DELIVERY_CASH) {
        return messages.transferToCash;
    } else if (methodName === DELIVERY_HOME) {
        return messages.deliveryHomeTitle;
    }
};
const getPaymentPrefix = (messages: CheckMessages, methodName: MethodName): string | undefined => {
    if (
        methodName === PAYMENT_BANK_CARD ||
        methodName === PAYMENT_BANK_CARD_110 ||
        methodName === PAYMENT_DEBIT_BANK_CARD_111 ||
        methodName === PAYMENT_CREDIT_BANK_CARD_112
    ) {
        return messages.transferToCard;
    } else if (methodName === PAYMENT_FLINKS) {
        return messages.transferFlink;
    } else if (methodName === PAYMENT_INTERAC) {
        return messages.transferInterac;
    } else if (methodName === PAYMENT_PEOPLE_TRUST_INTERAC) {
        return messages.transferPeopleTrustInterac;
    }
};

const getFormattedAccount = (
    methodName: MethodName,
    prefix: string | undefined = '',
    account = '',
    fromCountryId?: CountryId,
    accountType = PAYMENT,
): string => {
    if (methodName === DELIVERY_HOME) {
        return prefix;
    } else if (methodName === PAYMENT_INTERAC || methodName === PAYMENT_PEOPLE_TRUST_INTERAC) {
        return account;
    } else if (methodName === DELIVERY_CASH) {
        return prefix;
    }
    return accountType === DELIVERY ? `${prefix} ${account}` : `${prefix} •• ${account}`;
};

export class CheckService {
    static getFormattedDeliveryAccount(messages: CheckMessages, method: MethodName, fromCountryId: CountryId, countryId: CountryId, account = ''): string {
        return getFormattedAccount(method, getDeliveryPrefix(messages, method, countryId), account, fromCountryId, DELIVERY);
    }

    static getFormattedPaymentAccount(messages: CheckMessages, method: MethodName, userCountry: CountryId, account = ''): string {
        if (
            method === PAYMENT_BONUS ||
            method === PAYMENT_BANK_ACCOUNT ||
            method === PAYMENT_USA_BANK_ACCOUNT ||
            method === PAYMENT_OFAKIM ||
            method === PAYMENT_SOFORT ||
            method === PAYMENT_KLARNA ||
            method === PAYMENT_GIROPAY ||
            method === PAYMENT_IDEAL ||
            method === PAYMENT_BLIK ||
            method === PAYMENT_EPS ||
            method === PAYMENT_MBWAY ||
            method === PAYMENT_TRUSTLY ||
            method === PAYMENT_MODULR ||
            method === PAYMENT_PLAID ||
            method === PAYMENT_ACH ||
            method === PAYMENT_GLOBAL_ACCOUNT ||
            method === PAYMENT_GOOGLE_PAY ||
            method === PAYMENT_TINK ||
            method === PAYMENT_PAYPAL
        ) {
            return account;
        } else {
            return getFormattedAccount(method, getPaymentPrefix(messages, method), account, userCountry, PAYMENT);
        }
    }
}
